import { useEffect, useState } from 'react';

import useConversation from './useConversation';

export default function useIsTyping() {
  const conversation = useConversation();
  const [isTyping, setIsTyping] = useState(false);

  useEffect(() => {
    if (!conversation) return;

    const handleTypingStart = () => {
      setIsTyping(true);
    };

    const handleTypingEnd = () => {
      setIsTyping(false);
    };

    conversation.on('typingStarted', handleTypingStart);
    conversation.on('typingEnded', handleTypingEnd);

    return () => {
      conversation.off('typingStarted', handleTypingStart);
      conversation.off('typingEnded', handleTypingEnd);
    };
  }, [conversation]);

  return isTyping;
}
